import { DialogManagerProperties } from "../../control/properties/DialogManagerProperties";
/**
 * AbstractDialogManagerProperties.ts
 */
export class AbstractDialogManagerProperties extends DialogManagerProperties {
    equals(other) {
        return super.equals(other) &&
            this.messageDialogProperties.equals(other.messageDialogProperties) &&
            this.promptDialogProperties.equals(other.promptDialogProperties) &&
            this.realityCheckDialogProperties.equals(other.realityCheckDialogProperties) &&
            this.realityCheckNoOptionsDialogProperties.equals(other.realityCheckNoOptionsDialogProperties) &&
            this.responsibleGamingDialogProperties.equals(other.responsibleGamingDialogProperties) &&
            this.instructionsDialogProperties && this.instructionsDialogProperties.equals(other.instructionsDialogProperties) &&
            this.helpDialogProperties.equals(other.helpDialogProperties);
    }
}
//# sourceMappingURL=AbstractDialogManagerProperties.js.map